{
  "version": 1,
  "asset_id": "c8a2a3e2-904e-4151-87bf-87afa2de849c",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/c8a2a3e2-904e-4151-87bf-87afa2de849c/cert-ispm15.png",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/c8a2a3e2-904e-4151-87bf-87afa2de849c/cert-ispm15.png",
  "original_filename": "cert-ispm15.png",
  "size": 9857,
  "content_type": "image/png",
  "created_at": "2026-09-22T12:21:25Z"
}
